import { render, staticRenderFns } from "./cal-course.vue?vue&type=template&id=5bd31290&scoped=true&"
import script from "./cal-course.vue?vue&type=script&lang=js&"
export * from "./cal-course.vue?vue&type=script&lang=js&"
import style0 from "./cal-course.vue?vue&type=style&index=0&id=5bd31290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd31290",
  null
  
)

export default component.exports